<template>
  <Layout
    :primary-color="primaryColor"
    :secondary-color="secondaryColor"
    :terciary-color="terciaryColor"
    :quaternary-color="quaternaryColor"
    :quinary-color="quinaryColor"
    :senary-color="senaryColor"
    :septenary-color="septenaryColor"
    :octonary-color="octonaryColor"
    :nonary-color="nonaryColor"
    :decenary-color="decenaryColor"
    :undenary-color="undenaryColor"
    :is-loading="isLoading"
    :background-image-url="backgroundImageUrl"
  >
    <template #title>
      <Header v-if="title" class="p-2 mt-5 font-weight-bolder" :title="title" />
    </template>
    <template #switcher>
      <slot name="switcher"></slot>
    </template>
    <template #prices>
      <ul>
        <Shimmer
          v-for="(
            {
              cost: price,
              upgrade,
              currencySymbol,
              isAnnually,
              isMonthlyAnnualCommitment,
              name,
              specs,
              hasFreeTrial,
              previousPrice
            },
            index
          ) in prices"
          :key="index"
          :is-loading="isLoading"
          :is-highlighted="false"
          style="border-radius: var(--border-radius)"
        >
          <li :class="{ middle: isHighlighted(index) }">
            <PriceVerticalV2
              v-if="!isLoading"
              :price="price"
              :period="period"
              :title="name"
              :button-text="getFreeTrialButtonText(hasFreeTrial, buttonTextFreeTrial, buttonText)"
              :invoice-frequency-bold="isAnnually ? `${price}` : null"
              :invoice-frequency="
                getInvoiceFrequency(isMonthlyAnnualCommitment, isAnnually, priceDescription)
              "
              :specs="specs"
              :currency-symbol="currencySymbol"
              :is-button-enabled="upgrade"
              :is-annually="isAnnually"
              :is-monthly-annual-commitment="isMonthlyAnnualCommitment"
              :highlighted="isHighlighted(index)"
              :previous-price="previousPrice ? previousPrice : ''"
              @subscribe="$emit('subscribe', { price: prices[index] })"
            />
            <span v-if="isHighlighted(index)" class="highlight-text">
              <Icon :width="21" :height="21" color="inherit" icon="spark" />
              {{ planHighlightText }}</span
            >
          </li>
        </Shimmer>
      </ul>
    </template>
  </Layout>
</template>
<script>
import { mapGetters } from 'vuex';
import PriceVerticalV2 from '@/components/Prices/PriceVerticalV2';
import Shimmer from '@/components/Prices/PriceAtoms/Shimmer';
import Header from '@/components/Prices/PriceAtoms/Header';
import Layout from '@/components/Prices/Layouts/PricesVerticalV2';
import Icon from 'UI/Icon';

export default {
  components: { PriceVerticalV2, Shimmer, Header, Layout, Icon },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    title: {
      type: Array,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    primaryColor: {
      type: String,
      default: ''
    },
    secondaryColor: {
      type: String,
      default: ''
    },
    terciaryColor: {
      type: String,
      default: ''
    },
    quaternaryColor: {
      type: String,
      default: ''
    },
    quinaryColor: {
      type: String,
      default: ''
    },
    senaryColor: {
      type: String,
      default: ''
    },
    septenaryColor: {
      type: String,
      default: ''
    },
    octonaryColor: {
      type: String,
      default: ''
    },
    nonaryColor: {
      type: String,
      default: ''
    },
    decenaryColor: {
      type: String,
      default: ''
    },
    undenaryColor: {
      type: String,
      default: ''
    },
    prices: {
      type: Array,
      required: true
    },
    period: {
      type: String,
      required: true
    },
    priceDescription: {
      type: String,
      required: true
    },
    buttonTextFreeTrial: {
      type: String,
      required: true
    },
    planHighlightText: {
      type: String,
      required: true
    },
    backgroundImageUrl: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('plan-areas', ['getFreeTrialButtonText'])
  },
  methods: {
    isHighlighted(index) {
      return Boolean(index === 1);
    },
    getInvoiceFrequency(isMonthlyAnnualCommitment, isAnnually, priceDescription) {
      return isMonthlyAnnualCommitment
        ? this.$t('plans.common.cards.billedMonthlyAnnualCommitment')
        : isAnnually
        ? priceDescription
        : null;
    }
  }
};
</script>
